
import { Component, Vue, Prop } from 'vue-property-decorator'
import { GroupEntity, GroupStatus } from '@/types/catalogs/Groups'

@Component({
  name: 'SubGroupSelectionTreeItem'
})
export default class SubGroupSelectionTreeItem extends Vue {
  @Prop({ required: true })
  group: GroupEntity

  @Prop({ required: false, default: false })
  root: boolean

  @Prop({ required: false, default: true })
  opened: boolean

  @Prop({ required: false, default: false })
  readOnly: boolean

  open = false
  groupStatus = GroupStatus

  toggleOpen () {
    this.open = !this.open
  }

  created () {
    this.open = this.opened
  }

  get disabledGroups () {
    return this.group.allSubgroupIds.concat(this.group.siblingIds)
  }
}
